import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Select, Row, Col } from 'antd';
import dayjs from 'dayjs';
import {
    STATUS_OPTIONS,
    SOURCE_OPTIONS,
    PRE_REG_STATUS,
} from './constants';

const { TextArea } = Input;

const PreRegistrationFormModal = ({ open, editingRecord, confirmLoading, onCancel, onSubmit }) => {
    const [form] = Form.useForm();
    const isEdit = !!editingRecord;
    const status = Form.useWatch('status', form);

    useEffect(() => {
        if (open) {
            if (editingRecord) {
                form.setFieldsValue({
                    ...editingRecord,
                    studentBirthDate: editingRecord.studentBirthDate
                        ? dayjs(editingRecord.studentBirthDate)
                        : null,
                    followUpDate: editingRecord.followUpDate
                        ? dayjs(editingRecord.followUpDate)
                        : null,
                });
            } else {
                form.resetFields();
                form.setFieldsValue({ status: PRE_REG_STATUS.New, source: 0 });
            }
        }
    }, [open, editingRecord, form]);

    const handleOk = () => {
        form.validateFields().then((values) => {
            const payload = {
                ...values,
                studentBirthDate: values.studentBirthDate
                    ? values.studentBirthDate.toISOString()
                    : null,
                followUpDate: values.followUpDate ? values.followUpDate.toISOString() : null,
            };
            if (isEdit) payload.id = editingRecord.id;
            onSubmit(payload, isEdit);
        });
    };

    return (
        <Modal
            title={isEdit ? 'Ön Kayıt Düzenle' : 'Yeni Ön Kayıt'}
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            okText="Kaydet"
            cancelText="İptal"
            width={640}
            destroyOnClose
        >
            <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="parentFullName"
                            label="Veli Adı Soyadı"
                            rules={[{ required: true, message: 'Veli adı zorunlu' }]}
                        >
                            <Input placeholder="Veli adı soyadı" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="parentPhoneNumber"
                            label="Veli Telefon"
                            rules={[
                                { required: true, message: 'Telefon zorunlu' },
                                { min: 10, message: 'Telefon en az 10 hane olmalı' },
                            ]}
                        >
                            <Input placeholder="05XXXXXXXXX" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="studentFullName"
                            label="Öğrenci Adı Soyadı"
                            rules={[{ required: true, message: 'Öğrenci adı zorunlu' }]}
                        >
                            <Input placeholder="Öğrenci adı soyadı" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="studentBirthDate"
                            label="Öğrenci Doğum Tarihi"
                            rules={[{ required: true, message: 'Doğum tarihi zorunlu' }]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="DD/MM/YYYY"
                                placeholder="Doğum tarihi"
                                disabledDate={(d) => d && d > dayjs().endOf('day')}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="source" label="Kaynak">
                            <Select options={SOURCE_OPTIONS} placeholder="Nereden geldi?" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="status" label="Durum">
                            <Select options={STATUS_OPTIONS} />
                        </Form.Item>
                    </Col>
                </Row>
                {isEdit && (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="followUpDate" label="Tekrar Aranacak Tarih">
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format="DD/MM/YYYY"
                                    placeholder="Takip tarihi"
                                />
                            </Form.Item>
                        </Col>
                        {status === PRE_REG_STATUS.NotConverted && (
                            <Col span={12}>
                                <Form.Item name="notConvertedReason" label="Dönmeme Nedeni">
                                    <Input placeholder="Örn: Fiyat, uzaklık..." />
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                )}
                <Form.Item name="notes" label="Genel Not">
                    <TextArea rows={3} placeholder="Ön kayıt ile ilgili genel notlar..." />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PreRegistrationFormModal;
